import React, { useState, Fragment } from 'react';
import * as pdata from './powers';


const UNUSED_CATEGORIES = ['Inherent', 'Prestige', 'Incarnate'];

function make_change(handler) {
    return (e) => {
        handler(e.target.value);
    }
}

const GROUP_CLASS = 'form-group col-md-3';
const CONTROL_CLASS = 'form-control form-control-sm';

export const Archetype = ({value, onChange}) => {
    const [data, setData] = useState([]);
    if(!data.length)
    {
        pdata.get_archetypes()
            .then(setData);
    }
    
    return (
        <div className={GROUP_CLASS}>
            <label htmlFor="arch">Archetype:</label>
            <select name="arch" id="arch" className={CONTROL_CLASS} onChange={make_change(onChange)}>
                {data.map(val => (
                    <option key={val.name} value={val.name} selected={val.name == value ? true : undefined}>
                        {val.display_name}
                    </option>
                ))}
            </select>
        </div>
    );
}

export const PowerCategory = ({value, onChange}) => {
    const [data, setData] = useState(undefined);
    if(data === undefined)
    {
        const filter_cats = (new_data) => {
            setData(new_data.filter((cat) => UNUSED_CATEGORIES.indexOf(cat.name) == -1));
        }
        pdata.get_power_categories()
            .then(filter_cats);
    }

    const display_name = (cat) => {
        if(cat.archetype)
            return `${cat.archetype.display_name} ${cat.display_name}`;
        return cat.display_name;
    }
    let vals = data || [];
    return (
        <div className={GROUP_CLASS}>
            <label htmlFor="powercat">Power Category:</label>
            <select name="powercat" className={CONTROL_CLASS} id="powercat" onChange={make_change(onChange)}>
                <option key='' value=''></option>
                {vals.map(val => (
                    <option key={val.name} value={val.name} selected={val.name == value ? true : undefined}>
                        {display_name(val)}
                    </option>
                ))}
            </select>
        </div>
    );
}

export const Powerset = ({category, value, onChange}) => {
    const defaults = {
        data: [],
        category: ''
    };
    const [values, setValues] = useState(defaults);
    if(category != values.category)
    {
        pdata.get_power_sets(category)
            .then((data) => {
            setValues({data, category});
        });
    }

    return (
        <div className={GROUP_CLASS}>
            <label htmlFor="powerset">Power Set:</label>
            <select name="powerset" className={CONTROL_CLASS} id="powerset" onChange={make_change(onChange)}>
                <option key='' value=''></option>
                {values.data.map(val => (
                    <option key={val.name} value={val.name} selected={val.name == value ? true : undefined}>
                        {val.display_name}
                    </option>
                ))}
            </select>
        </div>
    );
}

export const Power = ({cat, set, value, onChange}) => {
    const defaults = {
        data: [],
        category: '',
        powerset: ''
    };
    const [values, setValues] = useState(defaults);
    if(set != values.powerset || cat != values.category)
    {
        pdata.get_powers(cat, set)
            .then((data) => {
            setValues({data, category: cat, powerset: set});
        });
    }
    const change_handler = (e) => {
        onChange(values.data.by_name(e.target.value));
    }

    return (
        <div className={GROUP_CLASS}>
            <label htmlFor="power">Power:</label>
            <select name="power" className={CONTROL_CLASS} id="power" onChange={change_handler}>
                <option key='' value=''></option>
                {values.data.filter(x => !x.hidden).map(val => (
                    <option key={val.name} value={val.name} selected={val.name == value ? true : undefined}>
                        {val.display_name}
                    </option>
                ))}
            </select>
        </div>
    );
}

export const PowerSelect = ({onChange}) => {
    const defaults = {
        archetype: '',
        category: '',
        powerset: '',
        power: ''
    };
    const [data, setData] = useState(defaults);
    const cat_changed = (value) => {
        setData({...data, category: value});
    }
    const pset_changed = (value) => {
        setData({...data, powerset: value});
    }
    const power_changed = (value) => {
        setData({...data, power: value.name});
        onChange(value);
    }
    return (
        <Fragment>
        <h5 className="card-title">Presets</h5>
        <div className="form-row">
            <PowerCategory value={data.category} onChange={cat_changed}/>
            <Powerset category={data.category} value={data.powerset} onChange={pset_changed}/>
            <Power cat={data.category} set={data.powerset} value={data.power} onChange={power_changed}/>
        </div>
        </Fragment>
    );
}
